import script from "./PreviewAuKycForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewAuKycForm.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewAuKycForm.vue?vue&type=style&index=0&id=a52809fc&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a52809fc"]])

export default __exports__